module.exports = __webpack_public_path__ + "media/icons/female-099e0016.svg";